export default __webpack_public_path__ + "static/media/_payment-successful-card.63023108.svg";